import Request from "@/common/net/request.js";
const request = new Request();
// 获取列表
export function getPage(data) {
  return request.send({
    url: `/pmy/freight/order/freight/manage/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 录入订单（客服代下单）
export function orderFreight(data) {
  return request.send({
    url: `/pmy/freight/order/freight`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 录入订单计算价格（客服代下单）
export function orderFreightPreFee(data) {
  return request.send({
    url: `/pmy/freight/order/freight/pre-fee`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 订单管理--导出
export function handleExport(data) {
  return request.send({
    url: `/pmy/freight/order/freight/manage/export`,
    method: "post",
    data,
    config: {
      responseType: "blob",
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 获取线路对应的省市区
export function getCode(data) {
  return request.send({
    url: `/pmy/sys/area/line-trees?cityCode=${data.cityCode}&reverse=${data.reverse?true:false}`,
    method: "get",
  });
}
